import { useEffect, useState } from 'react';
import { FaAngleRight, FaRegFileAlt } from 'react-icons/fa';
import CircleIcon from 'components/CircleIcon';
import SectionLabel from 'components/typography/SectionLabel';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import { getPluralForm } from 'shared/helpers/common';
import QuotesItem from './QuotesItem';
import ViewMoreDetails from './ViewMoreDetails';

export default function Quotes({ quotes = [] }) {
  const [overviewList, setOverviewList] = useState([]);
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  useEffect(() => {
    setOverviewList(quotes?.slice?.(0, 2) || []);
  }, [quotes]);

  return (
    <>
      <div className="mt-[40px] flex justify-between items-center">
        <div className="flex items-start">
          <CircleIcon className="mt-1" iconClassName="text-xl">
            <FaRegFileAlt style={{ fill: primaryColour }} />
          </CircleIcon>
          <SectionLabel
            label={`Latest ${getPluralForm('quote', quotes?.length)}`}
            className="ml-[20px] mt-1"
          />
        </div>
        {quotes?.length > 2 && (
          <ViewMoreDetails
            className="hidden lg:flex"
            label="View all quotes"
            icon={<FaAngleRight />}
            url={ROUTES_SELF_SERVICE.QUOTES}
          />
        )}
      </div>
      {overviewList.map((quote, index) => (
        <QuotesItem key={quote?.id || index} quote={quote} />
      ))}
      {quotes?.length > 2 && (
        <ViewMoreDetails
          className="mt-7 lg:hidden"
          label="View all quotes"
          icon={<FaAngleRight />}
          url={ROUTES_SELF_SERVICE.QUOTES}
          isSmallScreen
        />
      )}
    </>
  );
}
